import TrackWrapper from '@/common/TrackWrapper';
import useSeoData from '~/hooks/srp/useSeoData';
import { SeoProps } from '~/server-props/srp/contracts';
import formatEvent from '~/utilities/formatEvent';
import ContentMod from './CarGuide';
import InternalLinks from './InternalLinks';
import Reviews from './Reviews';

type OwnProps = {
  initialSeoProps?: SeoProps;
};

export default function SEOSection({ initialSeoProps }: OwnProps) {
  const { seoContent, seoLinks, seoReviews } = useSeoData(initialSeoProps);

  return (
    <>
      {seoContent?.contentMod ? (
        <TrackWrapper
          event={formatEvent('SEO', {
            action: 'viewed',
            section: 'Used Cars Guide'
          })}
          trackOnce
        >
          <ContentMod contentMods={seoContent} />
        </TrackWrapper>
      ) : null}
      {seoReviews && seoReviews.reviews.length > 0 ? (
        <TrackWrapper
          event={formatEvent('SEO', {
            action: 'viewed',
            section: 'Reviews'
          })}
          trackOnce
        >
          <Reviews seoReviews={seoReviews} />
        </TrackWrapper>
      ) : null}
      {seoLinks?.internalLinks ? (
        <TrackWrapper
          event={formatEvent('SEO', {
            action: 'viewed',
            section: 'Internal Links'
          })}
          trackOnce
        >
          <InternalLinks links={seoLinks?.internalLinks} />
        </TrackWrapper>
      ) : null}
    </>
  );
}
